/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Log_Status_FailedInputs */

const he_account_delivery_log_status_failed = /** @type {(inputs: Account_Delivery_Log_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נכשל`)
};

const en_account_delivery_log_status_failed = /** @type {(inputs: Account_Delivery_Log_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Account_Delivery_Log_Status_FailedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_log_status_failed = /** @type {((inputs?: Account_Delivery_Log_Status_FailedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Log_Status_FailedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_log_status_failed(inputs)
	return en_account_delivery_log_status_failed(inputs)
});